import { useState, useEffect, createContext } from "react";
import { Client, State } from "@twilio/conversations";
import { apiRequest } from "utils/api";

const ChatContext = createContext<any | null>(null);

const ChatConsumer = ChatContext.Consumer;

function ChatProvider({ children }: { children: JSX.Element }) {
	const [chatClient, setChatClient] = useState<Client>();
	const [initialized, setInitialized] = useState(false);
	const [online, setOnline] = useState<{
		[key: string]: boolean;
	}>({});

	function userUpdated(data: any) {
		setOnline({
			...online,
			[data.user.identity]: data.user.isOnline,
		});
	}

	function stateChanged(state: State) {
		setInitialized(state === "initialized");
	}

	useEffect(() => {
		async function loadClient() {
			try {
				const { token } = await apiRequest("/twilio/chatToken");

				const client = new Client(token);

				client.on("userUpdated", userUpdated);
				client.on("stateChanged", stateChanged);
				setChatClient(client);
			} catch (err) {
				console.error(err);
			}
		}

		loadClient();
	}, []);

	useEffect(() => {
		async function checkOnlineUsers() {
			if (chatClient?.connectionState !== "connected") return;
			try {
				const conversations = await chatClient.getSubscribedConversations();
				conversations?.items.forEach(async (c) => {
					const participants = await c.getParticipants();
					participants.forEach(async (p) => {
						await p.getUser();
					});
				});
			} catch (err) {
				console.error(err);
			}
		}
		if (chatClient) {
			checkOnlineUsers();
		}
	}, [chatClient]);

	return (
		<ChatContext.Provider
			value={{
				initialized,
				chatClient,
				online,
			}}
		>
			{children}
		</ChatContext.Provider>
	);
}
export { ChatContext, ChatConsumer, ChatProvider };
